"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalStyle = exports.typography = exports.fontTheme = exports.fonts = exports.defaultIconButtonSize = exports.defaultIconSize = exports.pageGutter = exports.maxPageSize = exports.colors = exports.brandColors = exports.palette = exports.popover = exports.borders = exports.BrandColorThemes = exports.breakpoints = exports.ThemeBreakpoints = exports.IconSizesPx = exports.IconSizes = void 0;
var styled_components_1 = require("styled-components");
var IconSizes;
(function (IconSizes) {
    IconSizes["xSmall"] = "xSmall";
    IconSizes["small"] = "small";
    IconSizes["default"] = "default";
    IconSizes["medium"] = "medium";
    IconSizes["large"] = "large";
})(IconSizes = exports.IconSizes || (exports.IconSizes = {}));
var IconSizesPx;
(function (IconSizesPx) {
    IconSizesPx[IconSizesPx["xSmall"] = 12] = "xSmall";
    IconSizesPx[IconSizesPx["small"] = 18] = "small";
    IconSizesPx[IconSizesPx["medium"] = 24] = "medium";
    IconSizesPx[IconSizesPx["large"] = 64] = "large";
})(IconSizesPx = exports.IconSizesPx || (exports.IconSizesPx = {}));
var ThemeBreakpoints;
(function (ThemeBreakpoints) {
    ThemeBreakpoints["wide"] = "wide";
    ThemeBreakpoints["palm"] = "palm";
    ThemeBreakpoints["smallPalm"] = "smallPalm";
    ThemeBreakpoints["largeHand"] = "largeHand";
    ThemeBreakpoints["mediumHand"] = "mediumHand";
    ThemeBreakpoints["smallHand"] = "smallHand";
    ThemeBreakpoints["minScreenSize"] = "minScreenSize";
})(ThemeBreakpoints = exports.ThemeBreakpoints || (exports.ThemeBreakpoints = {}));
exports.breakpoints = {
    wide: '1080px',
    palm: '768px',
    smallPalm: '650px',
    largeHand: '500px',
    mediumHand: '400px',
    smallHand: '350px',
    minScreenSize: '320px',
};
var BrandColorThemes;
(function (BrandColorThemes) {
    BrandColorThemes["error"] = "error";
    BrandColorThemes["serene"] = "serene";
    BrandColorThemes["twilight"] = "twilight";
    BrandColorThemes["mighty"] = "mighty";
})(BrandColorThemes = exports.BrandColorThemes || (exports.BrandColorThemes = {}));
exports.borders = {
    defaultBorderRadius: '6px',
};
exports.popover = {
    boxShadow: '0 0 2rem rgb(58 70 76 / 20%)',
};
exports.palette = {
    urbanPrimary: '#FAC600',
    grey: '#F5F5F3',
    black: '#000000',
    lime: '#F8F6AA',
    white: '#FFFFFF',
    greyBland: '#999999',
    greyDisabledT: '#AAAAAA',
    greyS: '#CCCCCC',
    primaryCtaText: '#441800',
    babyBlue: '#B5C7D3',
    navyBlue: '#2F3B3F',
    successGreen: '#13D377',
    attentionRed: '#E72F2F',
    attentionRedAlter: '#F95B45',
};
exports.brandColors = {
    error: exports.palette.attentionRed,
    serene: '#493954',
    twilight: exports.palette.navyBlue,
    mighty: exports.palette.attentionRedAlter,
};
exports.colors = {
    primaryColor: exports.palette.urbanPrimary,
    darkTitleFontColor: exports.palette.black,
    labelFontColor: exports.palette.greyBland,
    primaryFontColor: '#3C3C3C',
    primaryMediumFontColor: '#666666',
    primaryLightFontColor: exports.palette.greyBland,
    standoutText: exports.palette.attentionRedAlter,
    successText: exports.palette.successGreen,
    lime: exports.palette.lime,
    invalidFontColor: '#E72F2F',
    inactiveIconColor: '#D9D9D9',
    defaultIconColor: exports.palette.primaryCtaText,
    iconUiDark1: exports.palette.black,
    successAlert: exports.palette.successGreen,
    warningAlert: '#FF0000',
    attentionAlert: '#FFA500',
    errorColor: exports.palette.attentionRed,
    reviewBoxBorder: exports.palette.greyS,
    defaultHoverBackground: exports.palette.grey,
    dividerColor: exports.palette.greyS,
    outlineFocusColor: exports.palette.urbanPrimary,
    iconBorder: '#D9D9D9',
    lineItemBorder: '#D9D9D9',
    cartCountBackgroundColor: '#16D191',
    loadingAnimation: {
        start: exports.palette.greyS,
        mid: exports.palette.grey,
        end: exports.palette.greyS,
    },
    icon: {
        green: exports.palette.successGreen,
        warning: exports.palette.attentionRed,
    },
    box: {
        defaultBackgroundColor: exports.palette.grey,
        defaultBorderColor: exports.palette.greyBland,
        whiteThemeBorderColor: exports.palette.greyS,
    },
    practitionerBox: {
        background: exports.palette.white,
        border: exports.palette.white,
    },
    button: {
        primary: exports.palette.urbanPrimary,
        secondary: exports.palette.navyBlue,
        grey: '#F3F3F3',
        danger: '#E72F2F',
        success: exports.palette.successGreen,
        white: exports.palette.white,
        paypalBlue: '#00457C',
        lime: exports.palette.lime,
        boxShadowLight: 'rgba(0,0,0,0.06)',
        iconButtonBackground: exports.palette.grey,
        iconButtonBorderDark: exports.palette.greyS,
        disabledButtonBorder: exports.palette.greyS,
        ghostButtonBorder: exports.palette.black,
        ghostWhiteButtonBorder: exports.palette.white,
        font: {
            white: exports.palette.white,
            light: exports.palette.white,
            default: exports.palette.black,
            dark: exports.palette.black,
        },
        outline: {
            white: exports.palette.white,
            default: exports.palette.urbanPrimary,
            dark: exports.palette.navyBlue,
        },
    },
    form: {
        checkboxBorder: '#D9D9D9',
        checkboxActive: '#00CC57',
        radioBorder: '#D9D9D9',
        radioActive: '#00CC57',
        invalid: '#E72F2F',
    },
    label: {
        primary: exports.brandColors.twilight,
        secondary: exports.brandColors.serene,
        tertiary: exports.palette.successGreen,
        disabled: exports.palette.greyDisabledT,
    },
    input: {
        background: exports.palette.white,
        invalid: '#E72F2F',
        focus: exports.palette.urbanPrimary,
    },
    tag: {
        primary: exports.brandColors.twilight,
    },
    slots: {
        selected: exports.palette.successGreen,
        border: exports.palette.grey,
    },
    defaultHeadingColor: exports.palette.navyBlue,
    overlayColorRGBA: '73, 72, 92',
    white: exports.palette.white,
    black: '#000000',
};
exports.maxPageSize = '1170px';
exports.pageGutter = '2rem';
exports.defaultIconSize = IconSizesPx.medium;
exports.defaultIconButtonSize = 50;
exports.fonts = {
    heading: 'Larken',
    default: 'Roboto',
    defaultMedium: 'Roboto',
    defaultBold: 'Roboto',
    defaultSemibold: 'Roboto',
};
exports.fontTheme = {
    darkTitle: exports.colors.darkTitleFontColor,
    error: exports.colors.errorColor,
    primary: exports.colors.primaryFontColor,
    invalid: exports.colors.invalidFontColor,
    secondary: exports.colors.primaryLightFontColor,
    standout: exports.colors.standoutText,
    mediumBody: exports.colors.primaryMediumFontColor,
    mighty: exports.brandColors.mighty,
    label: exports.colors.labelFontColor,
    white: exports.colors.white,
    success: exports.colors.successText,
};
exports.typography = {
    h1: "\n    font-family: ".concat(exports.fonts.heading, ";\n    font-size: 3.6rem;\n    line-height: 4.8rem;\n    font-weight: 300;\n  "),
    h2: "\n    font-family: ".concat(exports.fonts.heading, ";\n    font-size: 3rem;\n    line-height: 4rem;\n    font-weight: 300;\n  "),
    h3: "\n    font-family: ".concat(exports.fonts.heading, ";\n    font-size: 2.6rem;\n    line-height: 3.5rem;\n    font-weight: 300;\n  "),
    h4: "\n    font-size: 2rem;\n    line-height: 2.8rem;\n    font-weight: 500;\n  ",
    h5: "\n    font-size: 1.6rem;\n    line-height: 2rem;\n    font-weight: 400;\n    ",
    h6: "\n  font-size: 1.2rem;\n  line-height: 1.5rem;\n  font-weight: 400;\n  ",
    titleXS: "\n    font-family: ".concat(exports.fonts.defaultMedium, ";\n    font-size: 1.6rem;\n    line-height: 2.4rem;\n    font-weight: 500;\n  "),
    titleXXL: "\n    font-family: ".concat(exports.fonts.heading, ";\n    font-size: 3rem;\n    line-height: 2.4rem;\n    font-weight: 300;\n  "),
    body: "\n    font-size: 1.4rem;\n    line-height: 2.2rem;\n  ",
    bodyLarge: "\n    font-size: 1.5rem;\n    line-height: 2.4rem;\n  ",
    bodyXLarge: "\n    font-size: 1.8rem;\n    line-height: 2.8rem;\n    font-weight: 400;\n  ",
    bodySmall: "\n    font-family: ".concat(exports.fonts.defaultMedium, ";\n    font-size: 1.2rem;\n    line-height: 2rem;\n    font-weight: 400;\n  "),
    span: "\n    font-family: ".concat(exports.fonts.defaultMedium, ";\n    font-size: 1.4rem;\n    line-height: 2.2rem;\n  "),
    legend: "\n    font-family: ".concat(exports.fonts.defaultMedium, ";\n    font-size: 1.4rem;\n    line-height: 1.8rem;\n  "),
    labelSMedium: "\n    font-family: ".concat(exports.fonts.defaultMedium, ";\n    font-size: 1rem;\n    line-height: 1.4rem;\n  "),
    labelMMedium: "\n    font-family: ".concat(exports.fonts.defaultMedium, ";\n    font-size: 1.4rem;\n    line-height: 2.2rem;\n  "),
};
exports.GlobalStyle = (0, styled_components_1.createGlobalStyle)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  @font-face {\n  font-family: 'Larken';\n  src: url('https://static.urban.co/fonts/Larken/webFonts/LarkenLight/font.woff') format('woff');\n  font-weight: 300;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Larken';\n  src: url('https://static.urban.co/fonts/Larken/webFonts/LarkenLightItalic/font.woff') format('woff');\n  font-weight: 300;\n  font-style: italic;\n  font-display: swap;\n}\n\n@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500&display=swap');\n\n  *, :after, :before {\n    box-sizing: border-box;\n  }\n\n  html {\n    font-size: 62.5%;\n    -webkit-font-smoothing: anti-aliased;\n    -moz-osx-font-smoothing: grayscale;\n  }\n\n  body {\n    font-family: \"", "\";\n    font-size: 1.4rem;\n    font-weight: 300;\n    padding: 0;\n    margin: 0;\n    color: ", ";\n  }\n\n  html, body {\n    min-height: 100vh;\n    min-width: 320px\n  }\n\n  img {\n    max-width: 100%;\n    vertical-align: middle;\n  }\n\n"], ["\n  @font-face {\n  font-family: 'Larken';\n  src: url('https://static.urban.co/fonts/Larken/webFonts/LarkenLight/font.woff') format('woff');\n  font-weight: 300;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Larken';\n  src: url('https://static.urban.co/fonts/Larken/webFonts/LarkenLightItalic/font.woff') format('woff');\n  font-weight: 300;\n  font-style: italic;\n  font-display: swap;\n}\n\n@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500&display=swap');\n\n  *, :after, :before {\n    box-sizing: border-box;\n  }\n\n  html {\n    font-size: 62.5%;\n    -webkit-font-smoothing: anti-aliased;\n    -moz-osx-font-smoothing: grayscale;\n  }\n\n  body {\n    font-family: \"", "\";\n    font-size: 1.4rem;\n    font-weight: 300;\n    padding: 0;\n    margin: 0;\n    color: ", ";\n  }\n\n  html, body {\n    min-height: 100vh;\n    min-width: 320px\n  }\n\n  img {\n    max-width: 100%;\n    vertical-align: middle;\n  }\n\n"])), exports.fonts.default, exports.colors.primaryFontColor);
var templateObject_1;
//# sourceMappingURL=b2c-theme.js.map


//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/b-apps_b2c-site_b2c-site_develop/node_modules/@urbanmassage/component-library/lib/Theme/b2c-theme.js
// module id = 43
// module chunks = 81